import React from 'react';
import ReactDOM from 'react-dom';
import { useSpring, animated } from 'react-spring';
import BezierEasing from 'bezier-easing';

type Mode = 'in' | 'out';
type Modes = { in: Mode; out: Mode };
type PageTransitionProps = {
  activated: boolean;
  mode: Mode;
};

export const TRANSITION_MODES: Modes = { in: 'in', out: 'out' };

export default (props: PageTransitionProps) => {
  const { activated = false, mode = TRANSITION_MODES.out } = props;
  const toHeight = mode === TRANSITION_MODES.out ? '100vh' : '0vh';
  const fromHeight = mode === TRANSITION_MODES.out ? '0vh' : '100vh';
  const anchorage = mode === TRANSITION_MODES.in ? 'top' : 'bottom';
  const main =
    typeof document !== 'undefined' && document.querySelector('.main');

  const [springProps] = useSpring(
    {
      to: { height: activated ? toHeight : fromHeight },
      from: { height: fromHeight },
      delay: mode === TRANSITION_MODES.in ? 500 : 0,
      config: {
        tension: 170,
        friction: 50,
        duration: 1000,
        easing: BezierEasing(0.72, -0.04, 0.18, 1.07)
      }
    },
    [activated]
  );

  const transition = (
    <animated.div
      style={{
        ...springProps,
        position: 'fixed',
        [anchorage]: 0,
        left: 0,
        width: '100vw',
        zIndex: 11,
        backgroundColor: '#000000'
      }}
    />
  );

  return mode === TRANSITION_MODES.in ? (
    transition
  ) : (
    <>{main && ReactDOM.createPortal(transition, main)}</>
  );
};
